import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { z } from 'zod';
import { BlockCard } from '../lib/block-card.js';
import { cx } from '../lib/cx.js';
import { InlineMarkdown } from '../lib/inline-markdown.js';
const TIMELINE_EMPHASES = ['normal', 'muted', 'strong'];
const TimelineEntrySchema = z
    .object({
    time: z.string().optional(),
    title: z.string(),
    detail: z.string().optional(),
    tag: z.string().optional(),
    emphasis: z.enum(TIMELINE_EMPHASES).optional(),
})
    .strict();
export const TimelinePropsSchema = z
    .object({
    title: z.string().optional(),
    entries: z.array(TimelineEntrySchema),
})
    .strict();
const EMPHASIS_TITLE_CLASS = {
    normal: 'text-foreground',
    muted: 'text-muted-foreground',
    strong: 'font-semibold text-foreground',
};
/** Renders a `timeline` block with a connected vertical rail. */
export function TimelinePrimitive({ title, entries }) {
    return (_jsx(BlockCard, { title: title, children: _jsx("ol", { className: "space-y-3", children: entries.map((entry, index) => {
                const isLast = index === entries.length - 1;
                return (_jsxs("li", { className: "relative pl-6", children: [isLast ? null : (_jsx("span", { "aria-hidden": true, className: "absolute bottom-[-0.75rem] left-[3px] top-2 w-px bg-border" })), _jsx("span", { "aria-hidden": true, className: "absolute left-0 top-1.5 size-2 rounded-full bg-primary/70 ring-4 ring-background" }), _jsxs("div", { className: "min-w-0 flex-1", children: [_jsxs("div", { className: "flex flex-wrap items-baseline gap-2", children: [entry.time ? (_jsx("span", { className: "text-xs tabular-nums text-muted-foreground", children: entry.time })) : null, _jsx("span", { className: cx('text-sm', EMPHASIS_TITLE_CLASS[entry.emphasis ?? 'normal']), children: _jsx(InlineMarkdown, { children: entry.title }) }), entry.tag ? (_jsx("span", { className: "rounded bg-muted px-1.5 py-0.5 text-[10px] font-medium text-muted-foreground", children: entry.tag })) : null] }), entry.detail ? (_jsx("p", { className: "mt-0.5 text-sm text-muted-foreground", children: _jsx(InlineMarkdown, { children: entry.detail }) })) : null] })] }, index));
            }) }) }));
}
